import type { AxiosInstance } from 'axios'

let client: AxiosInstance | null = null

export const registerProtectedFileClient = (instance: AxiosInstance): void => {
  client = instance
}

// True only for relative backend routes (need the bearer token). Absolute http(s) urls and
// already-local blob: urls are excluded — they load fine on their own.
export const isFileUrlProxied = (url: string) =>
  !!url && !url.startsWith('http') && !url.startsWith('blob:')

export const fetchProtectedBlob = async (url: string, signal?: AbortSignal): Promise<Blob> => {
  if (!client) {
    throw new Error('Protected file client is not registered')
  }
  const response = await client.get<Blob>(url, { responseType: 'blob', signal })
  return response.data
}

// Fetch a protected file with the authorized client and hand back a local object URL.
// Preserves whatever content-type the server sent (pdf, png…) — does not hardcode one.
export const fetchAuthorizedObjectUrl = async (
  endpoint: string,
  signal?: AbortSignal,
): Promise<string> => {
  const blob = await fetchProtectedBlob(endpoint, signal)
  return URL.createObjectURL(blob)
}
